import React from "react";
import "../../styles/LearningStreams.css";

const LearningStreams = () => {
  const programsData = [
    {
      id: 1,
      theme: "blue", // Overlay color class
      title: "US CPA (Certified Public Accountant)",
      // Image: Financial documents, calculator, auditing context
      bgImg: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=800&q=80",
      points: [
        "Globally respected accounting qualification.",
        "Covers <strong>Auditing, Financial Accounting, Regulation, and Business Concepts</strong>.",
        "Suitable for accounting & finance professionals aiming for multinational careers."
      ]
    },
    {
      id: 2,
      theme: "purple",
      title: "US CMA (Certified Management Accountant)",
      // Image: Strategic business meeting, corporate finance analysis
      bgImg: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=800&q=80",
      points: [
        "Focuses on management accounting & strategic finance.",
        "Ideal for professionals targeting corporate finance, business strategy, and leadership roles."
      ]
    },
    {
      id: 3,
      theme: "green",
      title: "EA (Enrolled Agent – US Tax Expert)",
      // Image: US Tax forms (1040), calculator, IRS context
      bgImg: "https://images.unsplash.com/photo-1586486855514-8c633cc6fd38?auto=format&fit=crop&w=800&q=80",
      points: [
        "Specialization in US taxation laws.",
        "Authorized to represent taxpayers before the IRS."
      ]
    }
  ];

  return (
    <section className="programs-section container">
      <h2 className="section-main-title">Our Programs</h2>
      
      <div className="programs-grid">
        {/* Top Row: 2 Cards */}
        <div className="row g-4 justify-content-center mb-4">
          {programsData.slice(0, 2).map((program) => (
            <div key={program.id} className="col-lg-6 col-md-12">
              {/* Card Container with Background Image */}
              <div 
                className="program-card" 
                style={{ backgroundImage: `url(${program.bgImg})` }}
              >
                {/* Color Overlay */}
                <div className={`card-overlay overlay-${program.theme}`}></div>
                
                {/* Content sits on top of overlay */}
                <div className="card-content position-relative">
                  <h3 className="program-title">
                    <span className="highlight-bg">{program.title}</span>
                  </h3>
                  <ul className="program-points-list">
                    {program.points.map((point, index) => (
                      <li key={index} dangerouslySetInnerHTML={{ __html: point }} />
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Row: 1 Card (Centered) */}
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10">
             <div 
                className="program-card" 
                style={{ backgroundImage: `url(${programsData[2].bgImg})` }}
              >
                <div className={`card-overlay overlay-${programsData[2].theme}`}></div>
                
                <div className="card-content position-relative text-center">
                  <h3 className="program-title d-inline-block">
                    <span className="highlight-bg">{programsData[2].title}</span>
                  </h3>
                  <ul className="program-points-list text-start d-inline-block mt-3">
                    {programsData[2].points.map((point, index) => (
                      <li key={index} dangerouslySetInnerHTML={{ __html: point }} />
                    ))}
                  </ul>
                </div>
              </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default LearningStreams;